import axios from "axios";
import AuthHandler from "./AuthHandler";
import { navigate } from "./navigation";

const baseURL =
  process.env.REACT_APP_ANALYTICS_BASE_URL;

const AnalyticsClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

AnalyticsClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

AnalyticsClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      AuthHandler(error.response.status, null, navigate);
    }
    return Promise.reject(error);
  }
);

export default AnalyticsClient;

